import { PublicClientApplication } from '@azure/msal-browser'

export const MFA_PENDING_KEY = 'mfaLoginPending'
export const MFA_TENANT_KEY = 'mfaTenantId'
export const MFA_RETURN_URL_KEY = 'mfaReturnUrl'
export const MFA_ISSUED_AT_KEY = 'mfaIssuedAt'

export const MSAL_SCOPES = ['User.Read', 'email', 'openid', 'profile', 'offline_access']

export const MFA_PENDING_TTL_MS = 10 * 60 * 1000

export const createMsalClient = (clientId: string, tenantId: string) => {
  return new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  })
}

export const setMfaPending = (tenantId: string, returnUrl: string) => {
  sessionStorage.setItem(MFA_PENDING_KEY, '1')
  sessionStorage.setItem(MFA_TENANT_KEY, tenantId)
  sessionStorage.setItem(MFA_RETURN_URL_KEY, returnUrl)
  sessionStorage.setItem(MFA_ISSUED_AT_KEY, String(Date.now()))
}

export const clearMfaPending = () => {
  sessionStorage.removeItem(MFA_PENDING_KEY)
  sessionStorage.removeItem(MFA_TENANT_KEY)
  sessionStorage.removeItem(MFA_RETURN_URL_KEY)
  sessionStorage.removeItem(MFA_ISSUED_AT_KEY)
}

export const readMfaPending = (): { tenantId: string; returnUrl: string; issuedAt: number } | null => {
  if (sessionStorage.getItem(MFA_PENDING_KEY) !== '1') return null

  const tenantId = sessionStorage.getItem(MFA_TENANT_KEY) || ''
  const returnUrl = sessionStorage.getItem(MFA_RETURN_URL_KEY) || '/'
  const issuedAt = Number(sessionStorage.getItem(MFA_ISSUED_AT_KEY) || '0')

  if (!tenantId || !issuedAt || Date.now() - issuedAt > MFA_PENDING_TTL_MS) {
    clearMfaPending()
    return null
  }

  return { tenantId, returnUrl, issuedAt }
}
